<template>
    <div class="base-my-trumpet" :class="{'mytrumpet-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">我的小号</div>
                <div class="ser" @click="isexplain = true">小号说明</div>
            </div>
            <div class="content-auto">
                <div class="tips">用户最多可在游戏中创建10个小号，创建后不可删除</div>
                <div>
                    <div class="list" v-for="(item, index) in list" :key="index">
                        <div class="name" v-show="item.stu == 0">
                            <div class="nicName">{{item.nick_name}}</div>
                            <span v-if="index == 0">【当前登录】</span>
                        </div>
                        <input type="text" class="name" :ref="item.ref" autofocus v-model="item.nick_name" @blur="onBlur(index)" v-show="item.stu == 1" />
                        <img src="~images/edit.png" @click="onEdit(index)" />
                    </div>
                </div>
            </div>
        </div>
        <div class="btn" @click="isadd = true" v-if="list.length < 10">增加小号</div>
        <transition name="component-fade" mode="out-in">
            <BaseTrumpetExplain @childExplain='childExplain' v-if="isexplain" />
            <BaseTrumpetAdd @childAdd='childAdd' v-if="isadd" />
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import BaseTrumpetExplain from './BasePopup/BaseTrumpetExplain'
    import BaseTrumpetAdd     from './BasePopup/BaseTrumpetAdd'
    import TheTips            from '@/components/TheTips'

    export default {
        name: 'BaseMyTrumpet',
        components: {
            BaseTrumpetExplain,
            BaseTrumpetAdd,
            TheTips
        },
        data () {
            return {
                msg: null,
                list: [],
                isexplain: false,
                isadd: false,
                accountData: {},
                app_uid: '',
                name: ''
            }
        },
        methods: {
            onBlur (index) {
                this.list[index].stu = 0
                this.name = this.list[index].nick_name
                if (this.name.replace(/\s*/g, "")) this.modifyName()
            },
            onEdit (index) {
                this.list[index].stu = 1
                this.app_uid = this.list[index].app_uid
                this.$nextTick(() => this.$refs.itemRef[index].focus())
            },
            // 修改小号
            modifyName () {
                let options = {
                    uid: this.accountData.uid,
                    appid: this.accountData.appid,
                    app_uid: this.app_uid,
                    nick_name: this.name
                };
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=modify_app_user_name', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.getList()
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            childExplain (event) {
                this.isexplain = event
            },
            childAdd (event) {
                this.isadd = event
                this.getList()
            },
            // 获取小号列表
            getList () {
                let options = {
                    uid: this.accountData.uid,
                    appid: this.accountData.appid
                }
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=app_user_list', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data.list
                        this.list.forEach(item => {
                            this.$set(item, 'stu', 0)
                            this.$set(item, 'ref', 'itemRef')
                        })
                        sessionStorage.setItem('setTrumpet', JSON.stringify(this.list))
                    }
                })
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            if (sessionStorage.getItem('setTrumpet')) {
                let setTrumpet = JSON.parse(sessionStorage.getItem('setTrumpet'))
                this.list = setTrumpet
            } else {
                this.getList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-my-trumpet {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                }
                .ser {
                    height: 132px;
                    font-size: 39px;
                    position: absolute;
                    right: 60px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                }
            }
            .content-auto {
                flex: 1;
                overflow-y: scroll;
                padding: 0 60px;
                .tips {
                    font-size: 39px;
                    margin: 80px 0 60px;
                }
                .list {
                    height: 120px;
                    border-radius: 18px;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 0 45px;
                    margin-bottom: 30px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .list:last-child {
                    margin-bottom: 60px;
                }
                .list .name {
                    flex: 1;
                    height: 120px;
                    color: #fff;
                    font-size: 39px;
                    border: 0;
                    background: transparent;
                    outline: none;
                    display: flex;
                    align-items: center;
                }
                .list .name .nicName {
                    max-width: 700px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .list .name span {
                    color: $color;
                }
                .list img {
                    width: 60px;
                    height: 60px;
                    margin-left: 45px;
                }
                .list:first-child .name .nicName {
                    max-width: 500px;
                }
            }
        }
        .btn {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            margin: 0 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    // 竖屏css
    .mytrumpet-sp {
        width: 100%;
        padding-bottom: 90px;
        .content {
            .header {
                height: 240px;
                border-radius: 60px 0 0 0;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
                .ser {
                    height: 240px;
                    font-size: 60px;
                    right: 80px;
                }
            }
            .content-auto {
                padding: 0 90px;
                .tips {
                    font-size: 60px;
                    margin: 120px 0 90px;
                }
                .list {
                    height: 200px;
                    border-radius: 32px;
                    padding: 0 60px;
                    margin-bottom: 54px;
                }
                .list:last-child {
                    margin-bottom: 90px;
                }
                .list .name {
                    height: 200px;
                    font-size: 70px;
                }
                .list img {
                    width: 100px;
                    height: 100px;
                    margin-left: 60px;
                }
            }
        }
        .btn {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin: 0 90px;
        }
    }
</style>